import { useNavigation } from '@/navigation/NavigationContex';
import { AccordionItem } from '../../components/AccordionItem';
import { AccordionItemContent } from '../../components/AccordionItemContent';
import { AccordionItemHeader } from '../../components/AccordionItemHeader';
import { translate } from '@/translation/translate.ts';
import { RenderField } from '@/form/fields/RenderField';

const AncestryAsian = () => {
  const { currentSlide } = useNavigation();

  const ancestryKorean = currentSlide!.fields.find(({ name }) => name === 'ancestryKorean');
  const ancestryFilipino = currentSlide!.fields.find(({ name }) => name === 'ancestryFilipino');
  const ancestryChinese = currentSlide!.fields.find(({ name }) => name === 'ancestryChinese');
  const ancestryVietnamese = currentSlide!.fields.find(({ name }) => name === 'ancestryVietnamese');
  const ancestryJapanese = currentSlide!.fields.find(({ name }) => name === 'ancestryJapanese');
  const ancestrySouthAsian = currentSlide!.fields.find(({ name }) => name === 'ancestrySouthAsian');
  const ancestryOtherAsian = currentSlide!.fields.find(({ name }) => name === 'ancestryOtherAsian');

  return (
    <AccordionItem>
      <AccordionItemHeader>{translate(currentSlide?.titles?.asian)}</AccordionItemHeader>
      <AccordionItemContent>
        <RenderField slideId={currentSlide!.id} field={ancestryKorean!} />
        <RenderField slideId={currentSlide!.id} field={ancestryFilipino!} />
        <RenderField slideId={currentSlide!.id} field={ancestryChinese!} />
        <RenderField slideId={currentSlide!.id} field={ancestryVietnamese!} />
        <RenderField slideId={currentSlide!.id} field={ancestryJapanese!} />
        <RenderField slideId={currentSlide!.id} field={ancestrySouthAsian!} />
        <RenderField slideId={currentSlide!.id} field={ancestryOtherAsian!} />
      </AccordionItemContent>
    </AccordionItem>
  );
};

export default AncestryAsian;
